import ReImg from 'reimg';

/* eslint-disable */
require('script-loader!file-saver');

export function savePdf(content, fileName) {
  saveAs(
    new Blob([content], {
      type: 'application/octet-stream',
    }),
    `${fileName}.pdf`,
  );
}

export function saveImage(canvas, fileName, type) {
  if (type === 'svg') {
    ReImg.ReImg.fromSvg(canvas).downloadPng(`${fileName}.png`);
  } else {
    canvas.toBlob(function (blob) {
      saveAs(blob, `${fileName}.png`);
    });
  }
}
